<script lang="ts">
  import { getContext } from "svelte";
  import {
    connectBrowserSigner,
    connectWalletConnect,
    ethereum,
  } from "../../store/ethereum";

  export let message: string;

  let loading = false;
  $: connected = $ethereum.signer != undefined;
  const { close } = getContext("simple-modal");

  let isTrust = window.ethereum ? window.ethereum.isTrust : false;

  const _connectMetamask = () => {
    if (window.ethereum == undefined) 
      return alert("Metamask browser extension not installed");
      
    loading = true;
    connectBrowserSigner()
      .then(() => {
        loading = false;
        close();
      })
      .catch((err) => {
        console.error("Connect error", err);
        loading = false;
      });
    // connectWeb3Modal()
    //   .then(() => {
    //     loading = false;
    //     close();
    //   })
    //   .catch((err) => {
    //     console.error("Connect error", err);
    //     loading = false;
    //   });
  };

  const _connectWalletConnect = () => {
    loading = true;
    connectWalletConnect()
      .then(() => {
        loading = false;
        close();
      })
      .catch((err) => {
        console.error("Connect error", err);
        loading = false;
      });
  };
</script>
<div class="modal_inner"> 
<h3 class="modal_heading">Connect Wallet</h3>

<p class="modal_p white_text">
  {message}
</p>

<p class="modal_p mb-4">
  We recommend the <a href="https://metamask.io">Metamask browser wallet</a> for
  chrome and firefox. Learn more About Ethereum Wallets here:
  <a href="https://ethereum.org/en/wallets/">ethereum.org/en/wallets</a>.
</p>

<button
  disabled={loading}
  on:click={_connectMetamask}
  class="modal_btn"
>
  <span class="text">
    {#if isTrust}
      Connect TrustWallet / Metamask
    {:else}
      Connect Via Metamask
    {/if}
  </span>
</button>

{#if isTrust}
  <span />
{:else}
  <button
    disabled={loading}
    on:click={_connectWalletConnect}
    class="modal_btn"
  >    
    <span class="text"> Connect Via WalletConnect </span>
  </button>
{/if}
</div>
<style>
  h3 {
    margin-top: 0px;
  }

  button {
    width: 100%;
    padding: 20px 20px !important;
    margin-bottom: 10px;
  }

  .muted {
    opacity: 0.5;
  }
</style>
